import { NgoPartnerDto } from 'src/app/models/trofaco/ngoPartnerDto';
import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { PlantingSiteDetailDto, PhotoPosition } from '../../../../models/trofaco/plantingSiteDetailDto';
import { PlantingSitePartnerDto } from '../../../../models/trofaco/plantingSitePartnerDto';
import { IsInvalidDirective } from '../../../core/directives/is-invalid.directive';
import { NgoPartnerService } from '../../../core/services/ngo-partner.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalGeneralInformationComponent } from './modal-general-information/modal-general-information/modal-general-information.component';
import { Subject } from 'rxjs';
import { ThrowStmt } from '@angular/compiler';
import { AppUserModel } from 'src/app/models/users/app-user.model';
import { UserService } from 'src/app/modules/core/services/user.service';
import { PdfFile } from 'src/app/models/trofaco/pdfFileDto';

export interface GeneralInfoSaved {
    site: PlantingSiteDetailDto;
    file?: File;
    LandOWerfile?: File;
    pdfFile?: PdfFile;
}

@Component({
    selector: 'app-general-information',
    templateUrl: './general-information.component.html',
    styleUrls: ['./general-information.component.css']
})
export class GeneralInformationComponent implements OnInit {
    currentUser: AppUserModel;
    isPDFUpload: boolean = false;
    isPDFChanged: boolean = false;
    pdfFileName: string;
    isPDFFileDelete: boolean = false;
    pdfErrorSize: boolean = false;

    get site(): PlantingSiteDetailDto {
        return this._site;
    }

    @Input()
    set site(value: PlantingSiteDetailDto) {
        this._site = { ...value };
    }

    get siteYear(): number {
        return new Date(this._site.plantingDate).getFullYear();
    }

    set siteYear(value: number) {
        let date = new Date();
        date.setFullYear(value);
        this._site.plantingDate = date;
    }

    years: number[];

    private _site: PlantingSiteDetailDto;

    newHeaderPhoto: File;
    newPDFFile: File;
    siteModal: PlantingSiteDetailDto;
    ngoModal: NgoPartnerDto[];

    @Input()
    set ngoPartners(value: NgoPartnerDto[]) {
        if (!value) {
            this._ngoPartners = value;
            return;
        }

        this._ngoPartners = value.map(ngo => ({
            ngoPartnerId: ngo.ngoPartnerId,
            partnerName: ngo.partnerName,
            partnerUrl: ngo.url,
            description: ngo.description,
            photo: ngo.photo
        }));
    }

    _ngoPartners: PlantingSitePartnerDto[];
    @Input()
    countries: string[];
    @Input()
    regions: string[];
    @Input()
    set saving(isSaving: boolean) {
        this.isSaving = isSaving;
    };

    isSaving = false;

    modalRef: BsModalRef;
    public isSaved$: Subject<boolean>;

    @Output()
    onSave = new EventEmitter<GeneralInfoSaved>();
    @Output()
    onCancel = new EventEmitter();

    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];


    constructor(
        private partnerService: NgoPartnerService,
        private _modalService: BsModalService,
        private userService: UserService) {
    }

    ngOnInit() {
        this.getCurrentUser();
        let firstYear = 2010;
        let yearToday = new Date().getFullYear();
        this.years = new Array(yearToday - firstYear + 2)
            .fill(0)
            .map((value, index) => index + firstYear).reverse();

        if (this.site.pdfUrl) {
            this.pdfFileName = this.site.pdfUrl.split('/').reverse()[0];
            this.isPDFUpload = true;
            this.isPDFFileDelete = false;
        }
    }

    save() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) return;

        this.onSave.emit({ site: this._site, file: this.newHeaderPhoto, LandOWerfile: this._site.newLandOwnerPhoto, pdfFile: { file: this.newPDFFile, isDeleted: this.isPDFFileDelete, isChanged: this.isPDFChanged  } });
        this.site.newLandOwnerPhoto = null;
    }

    cancel() {
        this.onCancel.emit();
    }

    creatingNew = false;
    createNewPartner = async (name: string): Promise<PlantingSitePartnerDto> => {
        this.creatingNew = true;
        let partner = await this.partnerService.createNgoPartner({ name: name, url: '' });
        this._ngoPartners.push(partner);
        this.creatingNew = false;
        return { ngoPartnerId: partner.ngoPartnerId, partnerName: partner.partnerName, partnerUrl: partner.url };
    }

    onPhotoSelected(photo: File) {
        this.newHeaderPhoto = photo;
        this.site.photoPosition = PhotoPosition.top;
    }

    onPDFSelected(pdfEvent: any) {
        this.pdfErrorSize = false;
        this.pdfErrorSize = pdfEvent.target.files[0].size > 100000000;
        if (!this.pdfErrorSize) {
            if(pdfEvent.target.files[0].type === 'application/pdf'){
                this.newPDFFile = pdfEvent.target.files[0];
                this.pdfFileName = this.newPDFFile.name;
                this.isPDFUpload = true;
                this.isPDFChanged = true;
                this.isPDFFileDelete = false;
            }
        }
    }

    onFilePDFDelete() {
        this.isPDFUpload = false;
        this.isPDFChanged = false;
        this.isPDFFileDelete = true;
        this.newPDFFile = null;
        this.pdfErrorSize = false;
    }

    trimAndLower(term: string, ngo: NgoPartnerDto): boolean {
        let pattern = '^' + term.trim().toLowerCase() + '$';
        let matchingRegex = new RegExp(pattern);
        return !!ngo.partnerName.toLowerCase().match(matchingRegex);
    }

    async openModal(isLandOwner: boolean, isCreate: boolean, ngoPartner?: NgoPartnerDto) {
        this.siteModal = { ... this.site };
        if (isCreate && isLandOwner) {
            this.resetStage();
        }
        else if (isCreate && !isLandOwner) {
            this.ngoModal = [];
        }
        else {
            this.siteModal = { ...this.site };
            if (!isLandOwner) {
                this.ngoModal = [];
                this.ngoModal.push(ngoPartner)
            }
        }

        const initialState = {
            site: this.siteModal,
            _ngoPartners: this._ngoPartners,
            isLandOwner: isLandOwner,
            isCreate: isCreate,
            ngoPartner: this.ngoModal
        };

        this.modalRef = this._modalService.show(ModalGeneralInformationComponent, {
            class: "modal-lg",
            initialState,
            keyboard: false,
        });

        this.modalRef.content.isSaved$.subscribe(async (value) => {
            if (value) {
                this.site = {} as PlantingSiteDetailDto;
                this.site = { ...this.siteModal };
            }

        });
    }

    deleteLandOwner() {
        this.site.landOwner = "";
        this.site.landOwnerDescription = "";
        this.site.newLandOwnerPhoto = null;
        this.site.landOwnerPhoto = null;
    }

    deletePlantingPartner(ngoId: string) {
        this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoId), 1);
    }

    resetStage() {
        this.siteModal.landOwner = "";
        this.siteModal.landOwnerDescription = "";
        this.siteModal.newLandOwnerPhoto = null;
        this.siteModal.landOwnerPhoto = null;
    }

    async getCurrentUser() {
        this.currentUser = await this.userService.getCurrentUserAsync();
    }

    toggleBanner() {
        this.site.enabledBanner = !this.site.enabledBanner;
    }
}
